// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/harness.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ChannelUser } from "./channel_pb.js";
import { file_agentplatform_v1_channel } from "./channel_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/harness.proto.
 */
export const file_agentplatform_v1_harness: GenFile = /*@__PURE__*/
  fileDesc("Ch5hZ2VudHBsYXRmb3JtL3YxL2hhcm5lc3MucHJvdG8SI2luZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxIsEGCg5CYWNrZ3JvdW5kVGFzaxIKCgJpZBgBIAEoCRIcCgl0ZW5hbnRfaWQYAiABKAlSCXRlbmFudF9pZBIYCgd1c2VyX2lkGAMgASgJUgd1c2VyX2lkEiYKDmFwcGxpY2F0aW9uX2lkGAQgASgJUg5hcHBsaWNhdGlvbl9pZBIaCghhZ2VudF9pZBgFIAEoCVIIYWdlbnRfaWQSLgoSc3ViX2FwcGxpY2F0aW9uX2lkGAYgASgJUhJzdWJfYXBwbGljYXRpb25faWQSHgoKc2Vzc2lvbl9pZBgHIAEoCVIKc2Vzc2lvbl9pZBI/CgZzdGF0dXMYCCABKA4yLy5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5UYXNrU3RhdHVzEiYKDmRlbGVnYXRlX2lucHV0GAkgASgJUg5kZWxlZ2F0ZV9pbnB1dBIgCgt0YXNrX3Jlc3VsdBgKIAEoCVILdGFza19yZXN1bHQSJAoNZXJyb3JfbWVzc2FnZRgLIAEoCVINZXJyb3JfbWVzc2FnZRIeCgpjcmVhdGVkX2F0GAwgASgDUgpjcmVhdGVkX2F0Eh4KCnVwZGF0ZWRfYXQYDSABKANSCnVwZGF0ZWRfYXQSIAoLZmluaXNoZWRfYXQYDiABKANSC2ZpbmlzaGVkX2F0Eh4KCmRlbGV0ZWRfYXQYDyABKANSCmRlbGV0ZWRfYXQSLgoSY2hhbm5lbF9hY2NvdW50X2lkGBAgASgJUhJjaGFubmVsX2FjY291bnRfaWQSIgoMY2hhbm5lbF90eXBlGBEgASgJUgxjaGFubmVsX3R5cGUSJgoOY2FsbGVyX3VzZXJfaWQYEiABKAlSDmNhbGxlcl91c2VyX2lkEhwKCWNoYXRfdHlwZRgTIAEoCVIJY2hhdF90eXBlEhgKB2NoYXRfaWQYFCABKAlSB2NoYXRfaWQSLgoSY2hhbm5lbF9tZXNzYWdlX2lkGBUgASgJUhJjaGFubmVsX21lc3NhZ2VfaWQSQAoGc2VuZGVyGBYgASgLMjAuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuQ2hhbm5lbFVzZXIqxwEKClRhc2tTdGF0dXMSGwoXVEFTS19TVEFUVVNfVU5TUEVDSUZJRUQQABIXChNUQVNLX1NUQVRVU19QRU5ESU5HEAESFwoTVEFTS19TVEFUVVNfUlVOTklORxACEhwKGFRBU0tfU1RBVFVTX1dBSVRJTkdfSElUTBADEhkKFVRBU0tfU1RBVFVTX0NPTVBMRVRFRBAEEhYKElRBU0tfU1RBVFVTX0ZBSUxFRBAFEhkKFVRBU0tfU1RBVFVTX0NBTkNFTExFRBAGQklaR2dpdGxhYi5pbmZpbmktYWkuY29tL21pemFyL2luZmluaWFpLWFnZW50aWMtaW5mcmEvY29tbW9uL2dycGNhcGlzL3YxO3YxYgZwcm90bzM", [file_agentplatform_v1_channel]);

/**
 * @generated from message infinigence.infini.agentplatform.v1.BackgroundTask
 */
export type BackgroundTask = Message<"infinigence.infini.agentplatform.v1.BackgroundTask"> & {
  /**
   * 任务ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 租户ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 2 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 3 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 主代理的 Application ID
   * @gotags: json:"application_id,omitempty"
   *
   * @generated from field: string application_id = 4 [json_name = "application_id"];
   */
  applicationId: string;

  /**
   * 主代理的 Agent 模版 ID
   * @gotags: json:"agent_id,omitempty"
   *
   * @generated from field: string agent_id = 5 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * 被委托的 subagent Application ID
   * @gotags: json:"sub_application_id,omitempty"
   *
   * @generated from field: string sub_application_id = 6 [json_name = "sub_application_id"];
   */
  subApplicationId: string;

  /**
   * 主代理当前 session (projectID)
   * @gotags: json:"session_id,omitempty"
   *
   * @generated from field: string session_id = 7 [json_name = "session_id"];
   */
  sessionId: string;

  /**
   * 任务状态
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.TaskStatus status = 8;
   */
  status: TaskStatus;

  /**
   * 原始委托内容 (JSON)
   * @gotags: json:"delegate_input,omitempty"
   *
   * @generated from field: string delegate_input = 9 [json_name = "delegate_input"];
   */
  delegateInput: string;

  /**
   * 任务最终结果 (JSON)
   * @gotags: json:"task_result,omitempty"
   *
   * @generated from field: string task_result = 10 [json_name = "task_result"];
   */
  taskResult: string;

  /**
   * 失败时的错误信息
   * @gotags: json:"error_message,omitempty"
   *
   * @generated from field: string error_message = 11 [json_name = "error_message"];
   */
  errorMessage: string;

  /**
   * 创建时间
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 12 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * 更新时间
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 13 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * 结束时间
   * @gotags: json:"finished_at,omitempty"
   *
   * @generated from field: int64 finished_at = 14 [json_name = "finished_at"];
   */
  finishedAt: bigint;

  /**
   * 删除时间
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 15 [json_name = "deleted_at"];
   */
  deletedAt: bigint;

  /**
   * 渠道账号 ID（用于 subagent 完成后推送通知）
   * @gotags: json:"channel_account_id,omitempty"
   *
   * @generated from field: string channel_account_id = 16 [json_name = "channel_account_id"];
   */
  channelAccountId: string;

  /**
   * 渠道类型
   * @gotags: json:"channel_type,omitempty"
   *
   * @generated from field: string channel_type = 17 [json_name = "channel_type"];
   */
  channelType: string;

  /**
   * 渠道用户 ID（caller_user_id）
   * @gotags: json:"caller_user_id,omitempty"
   *
   * @generated from field: string caller_user_id = 18 [json_name = "caller_user_id"];
   */
  callerUserId: string;

  /**
   * 聊天类型：p2p / group / thread（与 InboundMessage 一致）
   * @gotags: json:"chat_type,omitempty"
   *
   * @generated from field: string chat_type = 19 [json_name = "chat_type"];
   */
  chatType: string;

  /**
   * 聊天ID（根据 chat_type 决定含义）
   * @gotags: json:"chat_id,omitempty"
   *
   * @generated from field: string chat_id = 20 [json_name = "chat_id"];
   */
  chatId: string;

  /**
   * 原始消息平台 ID（用于推送通知时回复原始消息）
   * @gotags: json:"channel_message_id,omitempty"
   *
   * @generated from field: string channel_message_id = 21 [json_name = "channel_message_id"];
   */
  channelMessageId: string;

  /**
   * 消息发送者（含 open_id 等完整信息）
   * @gotags: json:"sender,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelUser sender = 22;
   */
  sender?: ChannelUser | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.BackgroundTask.
 * Use `create(BackgroundTaskSchema)` to create a new message.
 */
export const BackgroundTaskSchema: GenMessage<BackgroundTask> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_harness, 0);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.TaskStatus
 */
export enum TaskStatus {
  /**
   * 未指定
   *
   * @generated from enum value: TASK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 等待中
   *
   * @generated from enum value: TASK_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * 运行中
   *
   * @generated from enum value: TASK_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * 等待审批
   *
   * @generated from enum value: TASK_STATUS_WAITING_HITL = 3;
   */
  WAITING_HITL = 3,

  /**
   * 完成
   *
   * @generated from enum value: TASK_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * 失败
   *
   * @generated from enum value: TASK_STATUS_FAILED = 5;
   */
  FAILED = 5,

  /**
   * 取消
   *
   * @generated from enum value: TASK_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.TaskStatus.
 */
export const TaskStatusSchema: GenEnum<TaskStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_harness, 0);

